"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Summary = exports.Details = exports.Item = exports.Root = exports.classes = void 0;
const Accordion_1 = __importStar(require("@mui/material/Accordion"));
const AccordionDetails_1 = __importStar(require("@mui/material/AccordionDetails"));
const AccordionSummary_1 = __importStar(require("@mui/material/AccordionSummary"));
const IconButton_1 = require("@mui/material/IconButton");
const styles_1 = require("@mui/material/styles");
const PREFIX = "Accordion";
exports.classes = {
    noInnerPadding: `${PREFIX}-noInnerPadding`,
    detailsNoInnerPadding: `${PREFIX}-detailsNoInnerPadding`,
    summaryRoot: `${PREFIX}-summaryRoot`,
    summaryExpanded: `${PREFIX}-summaryExpanded`,
    summaryContent: `${PREFIX}-summaryContent`
};
exports.Root = (0, styles_1.styled)("div")(() => ({
    [`& .${AccordionSummary_1.accordionSummaryClasses.root}.Mui-expanded`]: {
        minHeight: "48px"
    },
    [`& .${Accordion_1.accordionClasses.root}.Mui-expanded`]: {
        margin: 0,
        minHeight: "48px"
    },
    "& .Mui-expanded": {
        margin: 0
    },
    [`&.${exports.classes.noInnerPadding}`]: {
        [`& .${AccordionDetails_1.accordionDetailsClasses.root}`]: {
            padding: 0
        }
    }
}));
exports.Item = (0, styles_1.styled)(Accordion_1.default)(({ theme }) => ({
    backgroundColor: theme.colours.pearl,
    color: theme.colours.slate,
    border: "1px",
    borderStyle: "solid",
    borderColor: theme.colours.storm,
    "&:nth-of-type(n+2)": {
        borderTop: 0
    },
    "& + .item": {
        borderTop: "none",
        marginTop: "-1px"
    },
    "&:last-of-type .details": {
        borderBottomLeftRadius: "3px",
        borderBottomRightRadius: "3px"
    },
    "&:hover": {
        color: theme.colours.charcoal,
        backgroundColor: theme.colours.alabaster,
        transition: "color 0.35s ease-in-out"
    }
}));
exports.Details = (0, styles_1.styled)(AccordionDetails_1.default)(({ theme }) => ({
    backgroundColor: theme.colours.white,
    borderTop: "1px",
    borderTopStyle: "solid",
    borderTopColor: theme.colours.storm,
    padding: "14px 14px 14px",
    [`&.${exports.classes.detailsNoInnerPadding}`]: {
        padding: 0
    }
}));
exports.Summary = (0, styles_1.styled)(AccordionSummary_1.default)({
    [`&.${exports.classes.summaryRoot}`]: {
        minHeight: "48px",
        [`& .${IconButton_1.iconButtonClasses.edgeEnd}`]: {
            marginRight: "-12px"
        },
        "&:nth-of-type(1)": {
            minHeight: "48px"
        }
    },
    [`& .${exports.classes.summaryContent}.Mui-expanded`]: {
        minHeight: "revert",
        margin: 0
    }
});
//# sourceMappingURL=data:application/json;base64,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